export const authTokenKey = 'authToken'
